export const ANSWERS_DATA = {
  q1: {
    answer: "살롱in양재천",

    next: {
      answerData: "quiz",
      DateVal: "answer01",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q1",
    },
  },
  q2: {
    answer: "마들렌",

    next: {
      answerData: "quiz",
      DateVal: "answer02",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q2",
    },
  },
  q3: {
    answer: "우쿠",

    next: {
      answerData: "quiz",
      DateVal: "answer03",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q3",
    },
  },
  q4: {
    answer: ["wine", "와인"],

    next: {
      answerData: "quiz",
      DateVal: "answer04",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q4",
    },
  },
  q5: {
    answer: "크로스비",

    next: {
      answerData: "quiz",
      DateVal: "answer05",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q5",
    },
  },
  q6: {
    answer: "수변무대",

    next: {
      answerData: "quiz",
      DateVal: "answer06",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q6",
    },
  },
  q7: {
    answer: "모자",

    next: {
      answerData: "quiz",
      DateVal: "answer07",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q7",
    },
  },
  q8: {
    answer: "god bless you",

    next: {
      answerData: "quiz",
      DateVal: "answer08",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q8",
    },
  },
  q9: {
    answer: "블레숑",

    next: {
      answerData: "quiz",
      DateVal: "answer09",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q9",
    },
  },
  q10: {
    answer: "ete",

    next: {
      answerData: "quiz",
      DateVal: "answer10",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q10",
    },
  },
  q11: {
    answer: "12",

    next: {
      answerData: "quiz",
      DateVal: "answer11",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q11",
    },
  },
  q12: {
    answer: "한양",

    next: {
      answerData: "quiz",
      DateVal: "answer12",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q12",
    },
  },
  q13: {
    answer: "봄이옵니다플라워",

    next: {
      answerData: "quiz",
      DateVal: "answer13",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q13",
    },
  },
  q14: {
    answer: "양재르옹",

    next: {
      answerData: "quiz",
      DateVal: "answer14",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q14",
    },
  },
  q15: {
    answer: "8",

    next: {
      answerData: "quiz",
      DateVal: "answer15",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q15",
    },
  },
  q16: {
    answer: "7",

    next: {
      answerData: "quiz",
      DateVal: "answer16",
      titImgclassName: "infoTit",
      hintWhetherIs: true,
      hintContent: "",
      counting: true,
      missionKey: "q16",
    },
  },
};
